import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-road-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center">
              <img 
                src="/lovable-uploads/719484f4-0730-46ce-81b1-42c4a08b3b01.png" 
                alt="WAY2LEARN DRIVING SCHOOL" 
                className="h-20 mr-2" 
              />
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted partner on the road to becoming a confident and safe driver.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-drivewise-400">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-drivewise-400">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-drivewise-400">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-drivewise-400">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-drivewise-400">About Us</Link>
              </li>
              <li>
                <Link to="/instructors" className="text-gray-300 hover:text-drivewise-400">Instructors</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-drivewise-400">Contact</Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-300 hover:text-drivewise-400">Register</Link>
              </li>
            </ul>
          </div>

          {/* Locations We Cover */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Locations We Cover</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <MapPin className="h-4 w-4 mr-2 text-drivewise-400" />
                <span className="text-gray-300">North London</span>
              </li>
              <li className="flex items-center">
                <MapPin className="h-4 w-4 mr-2 text-drivewise-400" />
                <span className="text-gray-300">West London</span>
              </li>
              <li className="flex items-center">
                <MapPin className="h-4 w-4 mr-2 text-drivewise-400" />
                <span className="text-gray-300">Central London</span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-drivewise-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300">167 - 169 Great Portland Street<br />London<br />W1W 5PF</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 text-drivewise-400 flex-shrink-0" />
                <span className="text-gray-300">+44 (0) 203 388 9595</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-drivewise-400 flex-shrink-0" />
                <span className="text-gray-300">info@way2learn.co.uk</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400">
          <p>© {currentYear} WAY2LEARN DRIVING SCHOOL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
